export default __webpack_public_path__ + "static/media/ic-chevron-up.c4d951d2.svg";